module.exports = __webpack_public_path__ + "img/Abby.c1f951fd.jpg";